import React, { useState, createContext } from "react";

import currentUserToMembership from "../../helpers/userToMembership";

export const OrganizationContext = createContext();

export function withOrganization(Component) {
  return (props) => {
    const [ selectedUser, setSelectedUser ] = useState(props.user);
    const [ selectedMembership, setSelectedMembership ] = useState(currentUserToMembership(props.user))

    return (
      <OrganizationContext.Provider value={{selectedUser, setSelectedUser, selectedMembership, setSelectedMembership}}>
        <Component {...props} />
      </OrganizationContext.Provider>
    )
  };
}
